<template>
  <div class="edit-profile-container">
    <div class="back" v-on:click="goBack">
      Back to Dashboard
    </div>

    <label>First Name</label>
    <input type="text" disabled v-model="user.first_name" placeholder="First Name" maxlength="20" />

    <label>Last Name</label>
    <input type="text" disabled v-model="user.last_name" placeholder="Last Name" maxlength="20" />

    <label>Email</label>
    <div class="message" v-bind:class="{error: validation.hasError('email')}">{{ validation.firstError('email') }}</div>
    <input type="text" v-bind:class="{errorInput: validation.hasError('email')}" v-model="email" placeholder="Email" maxlength="40" />

    <label>Phone Number</label>
    <div class="message" v-bind:class="{error: validation.hasError('phone')}">{{ validation.firstError('phone') }}</div>
    <input type="phone" v-bind:class="{errorInput: validation.hasError('phone')}" v-model="phone" placeholder="phone" maxlength="10" />

    <label>New Password</label>
    <div class="message" v-bind:class="{error: validation.hasError('password')}">{{ validation.firstError('password') }}</div>
    <input type="password" v-bind:class="{errorInput: validation.hasError('password')}" v-model="password" placeholder="New Password" />
    <div class="button" v-on:click="submit">Update</div>

    <div class="logout" v-on:click="logout">
      Logout of Powerslide
    </div>

    <div class="error-response" v-if="updateError">
      Error: {{errorMessage}}
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from 'simple-vue-validator'
import '../styles/base.css'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'EditProfile',
  data () {
    return {
      errorMessage: '',
      email: '',
      password: '',
      phone: '',
      updateError: false
    }
  },

  methods: {
    goBack: function () {
      this.$parent.setSelectedPane('slide-builder')
    },

    logout: function () {
      this.axios.get('/api/logout').then(() => {
        this.$router.push('/login')
        localStorage.clear()
        PS.user = {}
        window.PS.user = {}
      })
    },

    submit: function () {
      this.$validate().then((success) => {
        if (success) {
          let data = {
            email: this.user.email,
            phone: this.user.phone
          }

          // TODO: Setup update password
          // if (newPassword.length > 6) {
          //   data.new_password = newPassword
          // }

          this.axios.put('/api/user/' + this.user._id, data).then((response) => {
            this.$gtag.event('profile-updated', { method: 'Google' })
            this.$parent.setSelectedPane('slide-builder')
          }).catch((error) => {
            if (error.response.status === 400) {
              this.updateError = true
              this.errorMessage = error.response.data[2].message
            }
          })
        }
      })
    }
  },

  props: ['user'],

  validators: {
    email: function (value) {
      return Validator.value(value).required().email()
    },

    password: function (value) {
      return Validator.custom(function () {
        if (!Validator.isEmpty(value)) {
          if (value.length < 6) {
            return 'Must contain at least 6 characters'
          }
        }
      })
    },

    phone: function (value) {
      return Validator.value(value).required().digit().length(10)
    }
  },

  watch: {
    user: function (user, oldUser) {
      if (user.phone) {
        this.phone = user.phone
      }

      this.email = user.email
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 300px;
  }

  .error {
    color: var(--error);
  }

  .error-response {
    color: var(--error);
    margin-top: 1em;
  }

  .form-group {
    text-align: left;
  }

  input[type=text], input[type=password], input[type=phone] {
    border: 1px solid #ccc;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: 1em;
    outline: none;
    padding: 1em;
    width: 300px;
  }

  input:focus {
    outline: 5px solid var(--focus);
  }

  .logout {
    margin-top: 1.5em;
    padding: 1em 0;
    width: 300px;
  }

  .logout:hover {
    cursor: pointer;
    color: var(--secondary);
  }

  .message {
    display: inline-block;
    text-align: left;
  }

  @media only screen and (max-width: 819px) {
    input[type=text], input[type=password], input[type=phone] {
     width: 100%;
    }

    .logout {
      width: 100%;
    }
  }
</style>
